import React from 'react'
import { useSelector } from 'react-redux'
import Icon from '@mdi/react'
import {
    mdiCheckCircleOutline,
    mdiAlertCircleOutline,
    mdiCloseCircleOutline,
    mdiPower,
    mdiConnection,
    mdiLightningBoltOutline
} from '@mdi/js'
import { REPORT_SEVERITY, useReportTypes } from '../../hooks/useReportTypes'
import { CircularProgress } from '@material-ui/core'
import { Icon as MuiIcon } from '@material-ui/core'
import RodentCriticalIcon from '../../../../assets/svg/rodent-critical-icon.svg'
import DownCriticalIcon from '../../../../assets/svg/down-critical-icon.svg'

export default function DeviceStatus({ value, iconSize = 1 }) {
    const { theme } = useSelector(state => state.main)
    const { isLoading, severity } = useReportTypes(value)

    const iconSizePx = iconSize * 24

    if (isLoading) {
        return <CircularProgress size={10} />
    }

    if (severity === REPORT_SEVERITY.inactive) {
        return (
            <Icon
                path={mdiPower}
                size={`${iconSizePx}px`}
                color={theme.secondary}
            />
        )
    }

    if (severity === REPORT_SEVERITY.warning) {
        return (
            <Icon
                path={mdiAlertCircleOutline}
                size={`${iconSizePx}px`}
                color={theme.warning}
            />
        )
    }

    if (severity === REPORT_SEVERITY.down) {
        return (
            <MuiIcon>
                <img
                    src={DownCriticalIcon}
                    width={iconSizePx}
                    height={iconSizePx}
                />
            </MuiIcon>
        )
    }

    if (severity === REPORT_SEVERITY.catch) {
        return (
            <MuiIcon>
                <img
                    src={RodentCriticalIcon}
                    width={iconSizePx}
                    height={iconSizePx}
                />
            </MuiIcon>
        )
    }

    if (severity === REPORT_SEVERITY.critical) {
        return (
            <Icon
                path={mdiCloseCircleOutline}
                size={`${iconSizePx}px`}
                color={theme.error}
            />
        )
    }

    if (severity === REPORT_SEVERITY.info) {
        return (
            <Icon
                path={mdiCheckCircleOutline}
                size={`${iconSizePx}px`}
                color={theme.active}
            />
        )
    }

    return (
        <Icon
            path={mdiPower}
            size={`${iconSizePx}px`}
            color={theme.secondary}
        />
    )
}
